import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StorageService {
  private _appStorage: Map<string, any> = new Map<string, any>();

  constructor() { }

  getValueFromAppStorage(key: string): any{
    return this._appStorage.get(key);
  }

  setValueInAppStorage(key: string, value: any){
    this._appStorage.set(key, value);
  }

  clearAppStorage(){
    this._appStorage.clear();
  }

  getLocalStorageValue(key:string): any{
    return localStorage.getItem(key);
  }

  setLocalStorageValue(key:string, value: any){
    return localStorage.setItem(key, value);
  }

  clearLocalStorage(){
    return localStorage.clear();
  }

  clearSessionStorage(){
    return sessionStorage.clear();
  }

  public getValueFromLocalStorage(key: string): Promise<any> {
    return new Promise((resolve) => {
      const intervalId = setInterval(() => {
        const value = localStorage.getItem(key);
        if (value) {
          clearInterval(intervalId);
          resolve(value);
        }
      }, 500); // Poll every second (adjust as needed)
    });
  }
}
